import { render, staticRenderFns } from "./aria-label.vue?vue&type=template&id=8d12ab68&"
import script from "./aria-label.vue?vue&type=script&lang=js&"
export * from "./aria-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports